import {
  CREATE_VENDOR_SUCCESS,
  FETCH_VENDOR_SUCCESS,
  GET_VENDOR_SUCCESS,
  SAVE_VENDOR_QUERY,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_VENDOR_QUERY: {
      return {
        ...state,
        query: action.query,
      };
    }

    case GET_VENDOR_SUCCESS: {
      const query = { ...state.query };
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      };
    }

    case CREATE_VENDOR_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      };
    }

    case FETCH_VENDOR_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      };
    }

    default:
      return state;
  }
}
